import styled from '@emotion/styled'
import logo from '@src/images/logo/logo-260x54.png'

const FormHeader = () => {
	return (
		<Header>
			<Logo src={logo} alt="logo" />
		</Header>
	)
}

const Header = styled.div`
	width: 13rem;
	margin-bottom: 1rem;
`

const Logo = styled.img`
	width: 100%;
	height: 100%;
	object-fit: cover;
`

export default FormHeader
